// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Dialog_wrapper__1_HjU","body":"Dialog_body__wfRjZ","header":"Dialog_header__1mAlv"};